(() => {
  'use strict';
  const validEvents = new Set(['myzinergi_click', 'praktijk_click', 'afspraak_click', 'familieopstellingen_click', 'ademwerk_click']);
  let tagsLoaded = false;
  const privacy = () => window.Shopify?.customerPrivacy;
  const consent = () => privacy()?.currentVisitorConsent?.() || {};
  const panel = () => document.querySelector('[data-zt-cookie-panel]');
  function syncConsent() {
    const c = consent();
    const analytics = c.analytics === 'yes';
    const marketing = c.marketing === 'yes';
    if (window.gtag) window.gtag('consent', 'update', {analytics_storage: analytics ? 'granted' : 'denied', ad_storage: marketing ? 'granted' : 'denied', ad_user_data: marketing ? 'granted' : 'denied', ad_personalization: marketing ? 'granted' : 'denied'});
    if (!tagsLoaded && analytics && marketing) {
      tagsLoaded = true;
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
      window.gtag('consent', 'default', {analytics_storage:'granted',ad_storage:'granted',ad_user_data:'granted',ad_personalization:'granted'});
      window.dataLayer.push({'gtm.start': Date.now(), event:'gtm.js'});
      const gtm = document.createElement('script');
      gtm.async = true;
      gtm.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-NFZK9T2';
      document.head.appendChild(gtm);
      const ads = document.createElement('script');
      ads.async = true;
      ads.src = 'https://www.googletagmanager.com/gtag/js?id=AW-10956387688';
      document.head.appendChild(ads);
      window.gtag('js', new Date());
      window.gtag('config', 'AW-10956387688');
    }
  }
  function onReady() {
    syncConsent();
    const c = consent();
    const banner = panel();
    if (banner && !c.analytics && !c.marketing) banner.hidden = false;
  }
  function saveConsent(allowed) {
    const banner = panel();
    const status = banner?.querySelector('[role="status"]');
    if (!privacy()?.setTrackingConsent) {
      if (status) status.textContent = banner.dataset.error;
      return;
    }
    privacy().setTrackingConsent({analytics:allowed,marketing:allowed,preferences:allowed}, () => {
      const c = consent();
      if (c.analytics !== (allowed ? 'yes' : 'no')) {
        if (status) status.textContent = banner.dataset.error;
        return;
      }
      if (status) status.textContent = '';
      banner.hidden = true;
      syncConsent();
    });
  }
  document.addEventListener('visitorConsentCollected', syncConsent);
  document.addEventListener('click', event => {
    const target = event.target.closest?.('a,button');
    if (!target) return;
    if (target.matches('[data-zt-cookie-settings]')) {
      const banner = panel();
      if (banner) { banner.hidden = false; banner.querySelector('button')?.focus(); }
      return;
    }
    if (target.matches('[data-zt-cookie-accept]')) { saveConsent(true); return; }
    if (target.matches('[data-zt-cookie-reject]')) { saveConsent(false); return; }
    if (consent().analytics !== 'yes') return;
    let name = target.dataset.ztEvent;
    let placement = target.dataset.ztPlacement || 'navigation';
    if (!name && target.tagName === 'A') {
      let u;
      try { u = new URL(target.href, location.href); } catch { return; }
      if (u.hostname === 'myzinergi.com') name = 'myzinergi_click';
      else if (u.hostname === 'miekedams.myzinergi.com') name = u.hash === '#bookingChoices' ? 'afspraak_click' : 'praktijk_click';
      else if (u.pathname === '/pages/afspraak-maken') name = 'afspraak_click';
      else if (u.pathname === '/pages/breathwork') name = 'ademwerk_click';
      else if (u.pathname === '/pages/familieopstelling') name = 'familieopstellingen_click';
    }
    if (!validEvents.has(name)) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event:name,event_category:'zinergi_transition',link_placement:placement});
  });
  if (privacy()) onReady();
  else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => { if (!error) onReady(); });
})();
